const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

class ChatService {
  /**
   * Ottieni headers con token di autenticazione
   */
  getAuthHeaders() {
    const token = localStorage.getItem('auth_token');
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
    };
  }

  /**
   * Invia un messaggio alla chat
   */
  async sendMessage(courseId, message, history = [], mode = null, functions = []) {
    try {
      const response = await fetch(`${API_BASE_URL}/courses/${courseId}/chat/message`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({
          message,
          history,
          mode,
          functions,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Errore durante l\'invio del messaggio');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Errore invio messaggio:', error);
      throw error;
    }
  }

  /**
   * Ottieni modalità disponibili
   */
  async getModes() {
    try {
      const response = await fetch(`${API_BASE_URL}/chat/modes`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Errore durante il caricamento delle modalità');
      }

      const data = await response.json();
      return data.modes;
    } catch (error) {
      console.error('Errore caricamento modalità:', error);
      throw error;
    }
  }

  /**
   * Ottieni funzioni disponibili
   */
  async getFunctions() {
    try {
      const response = await fetch(`${API_BASE_URL}/chat/functions`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Errore durante il caricamento delle funzioni');
      }

      const data = await response.json();
      return data.functions;
    } catch (error) {
      console.error('Errore caricamento funzioni:', error);
      throw error;
    }
  }
}

export default new ChatService();
